import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";

import { TravelWalletSelection } from "./component";
import {
  getCreditToApply,
  getFetchApplicableTravelWalletItemsCallState,
  getIsTravelWalletCreditPaymentOnly,
  getIsTravelWalletOfferPaymentOnly,
  getOffers,
  getOfferToApply,
  getRewardsPaymentAccountReferenceId,
  getSelectedPaymentMethodId,
  getIsStackedTravelWalletPaymentOnly,
  getBestOfferOverall,
  getMaxApplicableTravelWalletCreditAmount,
  getUserDeselectedCredits,
  getUserDeselectedOffers,
  getApplicableCredit,
  getApplicableCreditsBreakdown,
  getIneligibleCreditsBreakdown,
} from "../../reducer";
import {
  setOfferToApply,
  setSelectedRewardsPaymentTotal,
  resetPaymentCardSelectedAccounts,
  setCreditToApply,
  setUserDeselectedCredits,
  setUserDeselectedOffers,
} from "../../actions/actions";
import { getTravelCreditsHistoryTransaction, getPartialHistoryValidFromTime } from "../../../travel-wallet/reducer";
import { getRewardsAccounts } from "../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => ({
  offers: getOffers(state),
  offerToApply: getOfferToApply(state),
  fetchApplicableTravelWalletItemsCallState:
    getFetchApplicableTravelWalletItemsCallState(state),
  selectedPaymentMethodId: getSelectedPaymentMethodId(state) ?? "",
  selectedRewardsPaymentAccountId: getRewardsPaymentAccountReferenceId(state),
  credits: getApplicableCredit(state),
  creditBreakdown: getApplicableCreditsBreakdown(state),
  creditsToApply: getCreditToApply(state),
  isStackedTravelWalletPaymentOnly: getIsStackedTravelWalletPaymentOnly(state),
  isTravelCreditPaymentOnly: getIsTravelWalletCreditPaymentOnly(state),
  isTravelWalletOfferPaymentOnly: getIsTravelWalletOfferPaymentOnly(state),
  creditsHistoryTransaction: getTravelCreditsHistoryTransaction(state),
  partialHistoryValidFromTime: getPartialHistoryValidFromTime(state),
  bestOverallOffer: getBestOfferOverall(state),
  rewardsAccounts: getRewardsAccounts(state),
  maxApplicableTravelWalletCredit:
    getMaxApplicableTravelWalletCreditAmount(state),
  userDeselectedCredits: getUserDeselectedCredits(state),
  userDeselectedOffers: getUserDeselectedOffers(state),
  ineligibleCreditsBreakdown: getIneligibleCreditsBreakdown(state),
});

export const mapDispatchToProps = {
  setOfferToApply,
  resetPaymentCardSelectedAccounts,
  setSelectedRewardsPaymentTotal,
  setCreditToApply,
  setUserDeselectedCredits,
  setUserDeselectedOffers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type TravelWalletSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedTravelWalletSelection = withRouter(
  connector(TravelWalletSelection)
);
